/**
 * Robustly converts any time string (12h or 24h) to a 24h HH:mm format.
 * Examples:
 * "04:00 AM" -> "04:00"
 * "4:00 PM" -> "16:00"
 * "16:00" -> "16:00"
 * "04:00" -> "04:00"
 */
const convertTo24Hour = (timeStr) => {
  if (!timeStr) return "04:00";

  // Clean the input
  const cleanStr = timeStr.trim().toUpperCase();

  // Try to match 12h format: "hh:mm AM/PM" or "hh:mmAM/PM"
  const match12h = cleanStr.match(/^(\d{1,2}):(\d{2})\s*(AM|PM)$/);
  if (match12h) {
    let hours = parseInt(match12h[1], 10);
    const minutes = match12h[2];
    const modifier = match12h[3];

    if (modifier === "PM" && hours < 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return `${String(hours).padStart(2, "0")}:${minutes}`;
  }

  // Try to match 24h format: "HH:mm"
  const match24h = cleanStr.match(/^(\d{1,2}):(\d{2})$/);
  if (match24h) {
    const hours = parseInt(match24h[1], 10);
    const minutes = match24h[2];
    return `${String(hours).padStart(2, "0")}:${minutes}`;
  }

  // Fallback to default if unparseable
  return "04:00";
};

export default convertTo24Hour;
